import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Ameerika jalgpall",
    Baseball: "Pesapall",
    Basketball: "Korvpall",
    Boxing: "Poks",
    Chess: "Male",
    Cricket: "Kriket",
    Darts: "Darts",
    Entertainment: "Meelelahutus",
    "E-Sports": "E-sport",
    Football: "Jalgpall",
    "Formula 1": "Vormel 1",
    "Gaelic Football": "Gaeli jalgpall",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Greyhound",
    Handball: "Käsipall",
    "Ice Hockey": "Jäähoki",
    IndyCar: "Indy Racing",
    MMA: "MMA",
    Nascar: "NASCAR",
    Politics: "Poliitika",
    "Rugby League": "Ragbi Liiga",
    "Rugby Union": "Ragbi Liit",
    Snooker: "Snuuker",
    "Table Tennis": "Lauatennis",
    Tennis: "Tennis",
    "Virtual Football": "Virtuaalne Jalgpall",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name}, et võita",
    WinFirstRound: "{name}, et võita esimene voor",
    FirstTouchdown: "{name}, et lüüa esimesena touchdown",
    FirstTry: "{name}, et lüüa esimesena proovimine",
    TotalGoals: "{name} eesmärgid kokku",
    TotalRuns: "{name} kokku jooksud",
    TotalPoints: "{name} Punkte kokku",
    TopBatsman: "{name}, et saada parimaks lööjaks",
    TopBowler: "{name}, et saada parimaks pallur",
    FirstScore: "{name} lööb esimesena skoori"
  },
  PromoTexts: {
    Pick: "Tehke oma valikud",
    Bet: "Panus",
    Pays: "Väljamakse"
  },
  DateTimeTexts: {
    Today: "Täna",
    Tomorrow: "Homme",
    Live: "Otse"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Tehke oma valikud",
    Return: "Väljamakse",
    Stake: "Panus",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Löödud väravad",
    shots: "Löögid",
    shots_on_target: "Löögid väravale",
    ball_possession: "Pallivaldamine",
    goals_conceded: "Loovutatud väravate arv",
    "Per match": "Mängu kohta",
    H2H: "Vastamisi",
    W: "V",
    D: "VI",
    L: "K",
    T: "VI",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
